import React, { Component } from "react"
import Section from "components/layout/Section"
import FormWrapper from "components/layout/Form_Wrapper"
import TemperatureEntryForm from "forms/Temperature_Entry_Form"
import RequireSubFeature from "components/hoc/Require_Sub_Feature"

class TemperatureEntry extends Component {
  render() {
    return (
      <Section>
        <FormWrapper>
          <TemperatureEntryForm valuesToEdit={{}} {...this.props} />
        </FormWrapper>
      </Section>
    )
  }
}

export default RequireSubFeature(TemperatureEntry)
